import type { RequestDetailViewState } from "./request-detail-view-types";
import { Send, X } from "lucide-react";
import { AutocompleteSelect } from "../../../../../shared/components/AutocompleteSelect";
import { planningRequestCategoryOptions, unitOptions } from "../../../procurement-options";

type Props = Pick<
  RequestDetailViewState,
  | "editing"
  | "saving"
  | "editForm"
  | "setEditing"
  | "setEditForm"
  | "saveRequest"
  | "isCompleted"
>;
export function RequestEditForm({
  editing,
  saving,
  editForm,
  setEditing,
  setEditForm,
  saveRequest,
  isCompleted,
}: Props) {
  return editing && !isCompleted ? (
        <section
          className="inline-form-card request-edit-card"
          role="dialog"
          aria-modal="true"
          aria-label="Talep bilgilerini düzenle"
        >
          <div className="section-heading compact">
            <div>
              <span className="section-kicker">Düzeltme görevi</span>
              <h2>İhtiyaç bilgilerini güncelle</h2>
              <p className="modal-description">
                İade edilen alanları tamamlayıp talebi yeniden iletin.
              </p>
            </div>
            <button
              type="button"
              className="icon-button"
              aria-label="Talep düzenleme penceresini kapat"
              onClick={() => setEditing(false)}
            >
              <X size={17} />
            </button>
          </div>
          <div className="inline-form-grid">
            <label>
              Ürün veya hizmet
              <input
                value={editForm.title}
                onChange={(event) =>
                  setEditForm((current) => ({
                    ...current,
                    title: event.target.value,
                  }))
                }
              />
            </label>
            <AutocompleteSelect
              label="Kategori"
              value={editForm.category}
              options={planningRequestCategoryOptions}
              allowCustom
              placeholder="Kategori ara veya yaz"
              onChange={(category) =>
                setEditForm((current) => ({ ...current, category }))
              }
            />
            <label className="form-field-wide">
              İhtiyacın açıklaması
              <textarea
                rows={3}
                value={editForm.description}
                onChange={(event) =>
                  setEditForm((current) => ({
                    ...current,
                    description: event.target.value,
                  }))
                }
              />
            </label>
            <label>
              Miktar
              <input
                type="number"
                min="0.001"
                step="0.001"
                value={editForm.quantity}
                onChange={(event) =>
                  setEditForm((current) => ({
                    ...current,
                    quantity: event.target.value,
                  }))
                }
              />
            </label>
            <AutocompleteSelect
              label="Birim"
              value={editForm.unit}
              options={unitOptions}
              allowCustom
              placeholder="Birim ara veya yaz"
              onChange={(unit) =>
                setEditForm((current) => ({ ...current, unit }))
              }
            />
            <label>
              İhtiyaç tarihi
              <input
                type="date"
                value={editForm.due}
                onChange={(event) =>
                  setEditForm((current) => ({
                    ...current,
                    due: event.target.value,
                  }))
                }
              />
            </label>
            <label>
              Öncelik
              <select
                value={editForm.priority}
                onChange={(event) =>
                  setEditForm((current) => ({
                    ...current,
                    priority: event.target.value,
                  }))
                }
              >
                <option value="NORMAL">Normal</option>
                <option value="HIGH">Yüksek</option>
                <option value="CRITICAL">Kritik</option>
              </select>
            </label>
          </div>
          <div className="inline-form-actions">
            <button
              className="secondary-button"
              onClick={() => setEditing(false)}
            >
              Vazgeç
            </button>
            <button
              className="approve-button"
              disabled={saving}
              onClick={saveRequest}
            >
              <Send size={15} /> {saving ? "Kaydediliyor" : "Kaydet ve ilet"}
            </button>
          </div>
        </section>
      ) : null;
}
